<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive 
            v-if="exportGroupsImportMode"
            mode='primary' :text="labelBtnGroupsImportMode" icon='excelxls' @click='exportExcelGroupsImportMode' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones" mode='primary' :text="$t('app.import')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('configurations.new_group')" icon="plus" @click="goToNewGroup" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <import-generic-dialog
        :vuexNamespace="vuexnamespace"
        :secondaryTemplate="true"
        :dialogOpen="showModalImport" 
        :activateSwitch1="true"
        :labelSwitch1="'Actualizar grupos'"
        :sizeLg="true"
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        @downloadTemplate="downloadTemplate"
        header="Importación de Grupos" 
        />
      <BaseElDialog
        title="Borrar grupo"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-group')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span :key="t" v-for="t in processMessageDeleteGroup" class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ t }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-group">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        title="Desvincular Estados"
        :visible.sync="showModalUnlinkStatuses"
        @open="handleOpenModalDialog('container-handleOpenModal-unlink-statuses')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkStatuses }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-statuses">
            <base-button class="w-full" @click="showModalUnlinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkStatusesHandler(); showModalUnlinkStatuses = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        title="Vincular Estados"
        :visible.sync="showModalLinkStatuses"
        :close-on-click-modal="!isSelectDropdownOpen"
        @open="handleOpenModalDialog([
          'container-handleOpenModal-link-statuses-body',
          'container-handleOpenModal-link-statuses',
          ])"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-link-statuses-body"
            :style="{'height':heightContainerSelect}"
            >
            <el-form
              ref="ruleForm"
            >
              <div class="lg:mb-2">
                <AccessibleElSelect
                  v-model="listaStatusesSelected"
                  prop="tagNombre"
                  :options="listaStatusesForAccessibleSelect"
                  :isMultiple="true"
                  :isDisabled="isLoadingSelectStatuses"
                  @visible-change="onExpand"
                  @change="onChangeInput"
                  id-prefix="groups-statuses"
                >
                  <template slot="label">{{$t('configurations.status')}}</template>
                </AccessibleElSelect>
              </div>
              
            </el-form>
          </div>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-link-statuses">
            <base-button class="w-full" v-if="isAllStatusesSelected" @click="handleUnSelectAllStatuses" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedDataStatuses || isLoadingSelectStatuses" :loading="isLoadingSelectStatuses"/>
            <base-button class="w-full" v-if="!isAllStatusesSelected" :disabled="!isLoadedDataStatuses || isLoadingSelectStatuses || isEmptyStatusesList" @click="handleSelectAllStatuses" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelectStatuses"/>
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkStatuses = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
              :loading="isLoadingSelectStatuses"
              :disabled="isLoadingSelectStatuses"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkStatusesHandler(); showModalLinkStatuses = false}"
              :loading="isLoadingSelectStatuses"
              :disabled="isLoadingSelectStatuses"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        title="Desvincular Usuarios"
        :visible.sync="showModalUnlinkUsers"
        @open="handleOpenModalDialog('container-handleOpenModal-unlink-users')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkUsers }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-users">
            <base-button class="w-full" @click="showModalUnlinkUsers = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkUsersHandler(); showModalUnlinkUsers = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        title="Vincular Usuarios"
        :visible.sync="showModalLinkUsers"
        :close-on-click-modal="!isSelectDropdownOpen"
        @open="handleOpenModalDialog([
          'container-handleOpenModal-link-users-body',
          'container-handleOpenModal-link-users',
          ])"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-link-users-body"
            :style="{'height':heightContainerSelect}"
            >
            <el-form
              ref="ruleForm"
            >
              <div class="lg:mb-2">
                <AccessibleElSelect
                  v-model="listaUsersSelected"
                  prop="tagNombre"
                  :options="listaUsersForAccessibleSelect"
                  :isMultiple="true"
                  :isDisabled="isLoadingSelectUsers"
                  @visible-change="onExpand"
                  @change="onChangeInput"
                  id-prefix="groups-users"
                >
                  <template slot="label">{{$t('configurations.users')}}</template>
                </AccessibleElSelect>
              </div>
            </el-form>
          </div>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-link-users">
            <base-button class="w-full" v-if="isAllUsersSelected" @click="handleUnSelectAllUsers" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedDataUsers || isLoadingSelectUsers" :loading="isLoadingSelectUsers"/>
            <base-button class="w-full" v-if="!isAllUsersSelected" :disabled="!isLoadedDataUsers || isLoadingSelectUsers || isEmptyUsersList" @click="handleSelectAllUsers" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelectUsers"/>
            <div class="w-48"></div>
            <base-button class="w-full" @click="showModalLinkUsers = false" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
              :loading="isLoadingSelectUsers"
              :disabled="isLoadingSelectUsers"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkUsersHandler(); showModalLinkUsers = false}"
              :loading="isLoadingSelectUsers"
              :disabled="isLoadingSelectUsers"/>
          </div>
        </template>
      </BaseElDialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/GroupsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { getGroups } from '@/services/configurations/groups/getGroups'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import { downloadGroupsExcel } from '@/services/configurations/groups/downloadGroupsExcel'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import { deleteGroup } from '@/services/configurations/groups/deleteGroup'
import { changeAvisosGrupos } from '@/services/configurations/groups/changeAvisosGrupos'
import { getAllStatus } from '@/services/configurations/status/getAllStatus'
import { linkGroupsToStatuses } from '@/services/configurations/groups/linkGroupsToStatuses'
import { unlinkGroupsToStatuses } from '@/services/configurations/groups/unlinkGroupsToStatuses'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getAllUsers } from '@/services/configurations/getAllUsers'
import { linkUsersGroupsMultiple } from '@/services/configurations/groups/linkUsersGroupsMultiple'
import { unlinkGroupsUsersMultiple } from '@/services/configurations/groups/unlinkGroupsUsersMultiple'
import { importGroups } from '@/services/configurations/imports/importGroups'
import { downloadTemplateGroups } from '@/services/configurations/imports/downloadTemplateGroups'
import { downloadTemplateGroupsReparto } from '@/services/configurations/imports/downloadTemplateGroupsReparto'
import { downloadExcelGroupsImportMode } from '@/services/companies/downloadExcelGroupsImportMode'

export default {
  name: 'vista-grupos',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    // UsersLinkTagsMultipleDialog,
    BaseElDialog,
    AccessibleElSelect,
    ImportGenericDialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 40,
      // Links
      listaStatuses: [],
      listaStatusesSelected: [],
      showModalLinkStatuses: false,
      showModalUnlinkStatuses: false,
      isLoadedData: false,
      loadingActionSelect: false,
      isLoadedDataStatuses: false,
      loadingActionSelectStatuses: false,
      loadingActionUnSelectStatuses: false,

      showModalLinkUsers: false,
      showModalUnlinkUsers: false,
      listaUsers: [],
      listaUsersSelected: [],
      isLoadedDataUsers: false,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('app.groups'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'groups',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 200, Descripcion: i18n.t('configurations.link_statuses') },
        { IdAccion: 201, Descripcion: i18n.t('configurations.unlink_statuses') },
        { IdAccion: 600, Descripcion: i18n.t('configurations.link_users') },
        { IdAccion: 601, Descripcion: i18n.t('configurations.unlink_users') },
        { IdAccion: 300, Descripcion: 'Activar enviar avisos', },
        { IdAccion: 301, Descripcion: 'Desactivar enviar avisos' },
        { IdAccion: 500, Descripcion: i18n.t('configurations.change_mode_template_edit') },
        { IdAccion: 0, Descripcion: 'Borrar' }
      ],
      processMessageUnlinkStatuses: '¿Estás seguro que deseas desvincular todos los estados a los grupos seleccionados?',
      processMessageUnlinkUsers: '¿Estás seguro que deseas desvincular todos los usuarios a los grupos seleccionados?',
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    exportGroupsImportMode () {
      if (this.role === 'Administrador') return true
      if (!this.hasSelected) return false
      const idEmpresa = this.selected[0].idEmpresa
      const idTipoGrupo = this.selected[0].idTipoGrupo
      if (this.selected.filter(x => x.idEmpresa === idEmpresa).length === this.selected.length &&
        this.selected.filter(x => x.idTipoGrupo === idTipoGrupo).length === this.selected.length &&
        this.selected.filter(x => x.idTipoGrupo === 1 /* Sin Gestor NEOs */).length === 0) return true
      return false
    },
    labelBtnGroupsImportMode: function () {
      if (this.hasSelected) return this.$i18n.t('groups.export_excel_import') + ' (Seleccionados)'
      return this.$i18n.t('groups.export_excel_import')
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    processMessageDeleteGroup () {
      return [
        'Al eliminar estos grupos, la acción afectará a los Usuarios, Notificaciones y Reglas que tengan vinculados dichos grupos.',
        '¿Estás seguro que deseas borrar los grupos seleccionados?',
      ]
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isEmptyStatusesList: function () {
      return this.listaStatuses === undefined || this.listaStatuses === null || this.listaStatuses.length === 0
    },
    isEmptyUsersList: function () {
      return this.listaUsers === undefined || this.listaUsers === null || this.listaUsers.length === 0
    },
    listaStatusesForAccessibleSelect () {
      return this.listaStatuses.map(item => ({
        id: item.idEstado,
        value: item.idEstado,
        name: item.Descripcion
      }))
    },
    listaUsersForAccessibleSelect () {
      return this.listaUsers.map(item => ({
        id: item.id,
        value: item.id,
        name: item.value
      }))
    },
    isLoadingSelectStatuses: function () {
      return this.loadingActionSelectStatuses || this.loadingActionSelectStatuses
    },
    isLoadingSelectUsers: function () {
      return this.loadingActionSelectUsers || this.loadingActionSelectUsers
    },
    isAllStatusesSelected: function () {
      if (this.listaStatuses.length === this.listaStatusesSelected.length) return true
      else return false
    },
    isAllUsersSelected () {
      if (this.listaUsers.length === this.listaUsersSelected.length) return true
      else return false
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isMoreActionsVisible: function () {
      return this.hasSelected && this.getAccionesPosibles !== undefined && this.getAccionesPosibles.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 0 ? 'trash' 
          : action === 500 ? 'editpencil' 
            : action === 600 ? 'useradd'
              : action === 601 ? 'userremove'
                : action === 300 ? 'mailcheck'
                  : action === 301 ? 'mailcross'
                    : action === 200 ? 'link'
                      : 'unlink'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Quitamos poder eliminar grupos pool y acciones de estados y editar campos
        if (this.selected.length !== this.selected.filter(x => x.idTipoGrupo !== 1).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 0)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
        }
        // Quitamos poder realizar acciones de gestión a grupos de reparto
        if (this.selected.length !== this.selected.filter(x => x.idTipoGrupo !== 3).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 600 && x.IdAccion !== 601)
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
        } else {
          // Quitamos vinculaciones para usuarios y editar campos de diferentes clientes
          const idEmpresa = this.selected[0].idEmpresa
          if (this.selected.length !== this.selected.filter(x => x.idEmpresa === idEmpresa).length) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 600)
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 500)
          }
          // Quitamos acciones con estados si el grupo puede ver todos los estados
          if (this.selected.length !== this.selected.filter(x => x.VerTodoEstados === false).length) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200 && x.IdAccion !== 201)
          }
        }
      }
      return listaAccionesFinal
    },
    firstGroupSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].IdGrupo
      return 0
    }
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
    showModalLinkUsers: async function (val, oldVal) {
      this.isLoadedData = false
      try {
        this.isLoadedDataUsers = false
        if (val === true) {
          const data = await getAllUsers({ idGrupo: this.firstGroupSelected })
          if (data.blnError === true) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            // console.log('usuarios', data)
            data.respuesta.forEach(row => {
              this.listaUsers.push({ id: row.IdUsuario, value: row.Usuario })
            })
          }
        } else {
          this.listaUsers = []
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
        this.isLoadedDataUsers = true
      }
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.downloadStatuses()
    this.data = await this.applyFilters()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importGroups(file, { idCliente: form.idCliente, actualizarGrupos: form.switch1 })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateGroups()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-grupos-gestion.xlsx')
        }
        const responseReparto = await downloadTemplateGroupsReparto()
        if (responseReparto.blnError === true) {
          this.doFeedback(responseReparto.msgError + ' [Código de error: ' + responseReparto.codError + ']')
        } else {
          this.downloadBlob(responseReparto, 'plantilla-importacion-grupos-reparto.xlsx')
        }
      } catch (error) {
        console.error(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    onExpand (value) {
      // console.log('expand OPEN')
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      // console.log('onChangeInput', 'onChangeInput')
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    applyLinkStatusesHandler: async function () {
      this.showModalLinkStatuses = false 
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idEstados: [], idGrupos: [] }
        payload.idEstados = this.listaStatusesSelected
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
        const response = await linkGroupsToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
        this.listaStatusesSelected = []
        this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkUsersHandler: async function () {
      this.showModalLinkUsers = false 
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idUsuarios: [], idGrupos: [] }
        payload.idUsuarios = this.listaUsersSelected
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
        const response = await linkUsersGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
        this.listaUsersSelected = []
        this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadStatuses: async function () {
      this.isLoadedDataStatuses = false
      try {
        const data = await getAllStatus()
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.listaStatuses = data.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedDataStatuses = true
      }
    },
    toggleDialogLinkStatuses: function () {
      if (this.showModalLinkStatuses && this.isLoadingSelectStatuses) return
      this.listaStatusesSelected = []
      this.showModalLinkStatuses= !this.showModalLinkStatuses
    },
    toggleDialogLinkUsers: function () {
      if (this.showModalLinkUsers && this.isLoadingSelectUsers) return
      this.listaUsersSelected = []
      this.showModalLinkUsers= !this.showModalLinkUsers
    },
    handleSelectAllStatuses: async function () {
      await this.handleUnSelectAllStatuses()
      this.loadingActionSelectStatuses = true
      this.listaStatuses.forEach(element => {
        setTimeout(() => {
          this.listaStatusesSelected.push(element.idEstado)
          if (this.listaStatusesSelected.length === this.listaStatuses.length) {
            this.loadingActionSelectStatuses = false
            this.loadingActionUnSelectStatuses = false
          }
        }, 100)
      })
    },
    handleUnSelectAllStatuses: async function () {
      this.loadingActionUnSelectStatuses = true
      const staticLength = this.listaStatusesSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaStatusesSelected.pop()
          if (this.listaStatusesSelected.length === 0) this.loadingActionUnSelectStatuses = false
        }, 100)
      }
    },
    handleSelectAllUsers: async function () {
      await this.handleUnSelectAllUsers()
      this.loadingActionSelectUsers = true
      this.listaUsers.forEach(element => {
        setTimeout(() => {
          this.listaUsersSelected.push(element.id)
          if (this.listaUsersSelected.length === this.listaUsers.length) {
            this.loadingActionSelectUsers = false
            this.loadingActionUnSelectUsers = false
          }
        }, 100)
      })
    },
    handleUnSelectAllUsers: async function () {
      this.loadingActionUnSelectUsers = true
      const staticLength = this.listaUsersSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaUsersSelected.pop()
          if (this.listaUsersSelected.length === 0) this.loadingActionUnSelectUsers = false
        }, 100)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Nombre)
      this.$router.push({ name: 'configurations/groups/details', params: { id: event.dataItem.IdGrupo } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
      // Old sin fix
      // this.kendo.columns = options.columns
    },
    exportExcelGroupsImportMode: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const payload = {}
      if (this.hasSelected) {
        payload.idGrupos = this.selected.map(x => x.IdGrupo)
      }
      try {
        const response = await downloadExcelGroupsImportMode(payload)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupos-formato-importacion.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        tieneDescripcion: data.tieneDescripcion ? data.tieneDescripcion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.IdGrupo)
          payload.listaIDs = selectedIDs
        }
        const response = await downloadGroupsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupos.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    // getColumnsGroupExcel: function () {
    //   const columns = this.kendo.columns.filter(x => {
    //     if ((x.hidden === false || x.hidden === undefined) && x.field !== 'selected' && x.field !== undefined) return x
    //   }).sort((a, b) => {
    //     return a.orderIndex - b.orderIndex
    //   }).map(x => {
    //     return { columna: x.field, group: false }
    //   })
    //   this.kendo.group.forEach(group => {
    //     columns.map(x => {
    //       if (x.columna === group.field) x.group = true
    //       return x
    //     })
    //   })
    //   return columns
    // },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        EnUso: data.enUso ? data.enUso.value : null,
        tieneDescripcion: data.tieneDescripcion ? data.tieneDescripcion.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getGroups(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.Respuesta.forEach(o => {
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    // getObjOrder: function () {
    //   let obj = {}
    //   if (this.kendo.group.length > 0) {
    //     this.kendo.group.forEach(element => {
    //       let name = element.field.toLowerCase()
    //       if (name.includes('.')) {
    //         name = name.split('.')[0]
    //       }
    //       obj[name] = (element.dir === undefined || element.dir === 'asc')
    //     })
    //     obj = { order: obj }
    //   }
    //   const obj2 = {}
    //   if (this.kendo.sort.length > 0) {
    //     this.kendo.sort.forEach(element => {
    //       let name = element.field.toLowerCase()
    //       if (name.includes('.')) {
    //         name = name.split('.')[0]
    //       }
    //       obj2[name] = (element.dir === 'asc')
    //     })
    //     if (obj.order) {
    //       obj.order = { ...obj.order, ...obj2 }
    //     } else {
    //       obj = { order: obj2 }
    //     }
    //   }
    //   return obj
    // },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 0) { // borrar
        this.deleteGroup()
      } else if (this.selectedAction.IdAccion === 201) { // Unink statuses
        this.unlinkStatuses()
      } else if (this.selectedAction.IdAccion === 200) { // Link statuses
        this.toggleDialogLinkStatuses()
      } else if (this.selectedAction.IdAccion === 300 || this.selectedAction.IdAccion === 301) { // Avisos
        this.changeAvisosHandler(this.selectedAction.IdAccion === 300)
      } else if (this.selectedAction.IdAccion === 601) { // Unink users
        this.unlinkUsers()
      } else if (this.selectedAction.IdAccion === 600) { // Link users
        this.toggleDialogLinkUsers()
      } else if (this.selectedAction.IdAccion === 500) { // Plantilla modo edicion
        this.templateEditModeHandler()
      } else {
        console.error('Acción desconocida')
      }
    },
    templateEditModeHandler () {
      const data = {
        groups: this.selected.map(x => x.IdGrupo)
      }
      const idEmpresa = this.selected.map(x => x.idEmpresa)[0]
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        this.$router.push({ name: 'configurations/clients/template/groups', params: { data: data, id: idEmpresa } })
      } else {
        this.$router.push({ name: 'configurations/template/groups', params: { data: data } })
      } 
    },
    deleteGroup: async function () {
      this.showModal = !this.showModal
    },
    unlinkStatuses: async function () {
      this.showModalUnlinkStatuses = !this.showModalUnlinkStatuses
    },
    unlinkUsers: async function () {
      this.showModalUnlinkUsers = !this.showModalUnlinkUsers
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewGroup: function () {
      this.$router.push({ name: 'configurations/groups/details', params: { id: -1 } })
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        for (const element of this.selected) {
          payload.idGrupos.push(element.IdGrupo)
        }
        const response = await deleteGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    changeAvisosHandler: async function (activarAviso) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: [],
          accion: 1,
          valor: activarAviso,
        }
        for (const element of this.selected) {
          payload.idGrupos.push(element.IdGrupo)
        }
        const response = await changeAvisosGrupos(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    unlinkStatusesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IdGrupo)
        }
        const response = await unlinkGroupsToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    unlinkUsersHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IdGrupo)
        }
        const response = await unlinkGroupsUsersMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
